import { api } from '../../fetchWrapper';
import { API_ENDPOINTS, getEndpoint } from '../../apiConstants';

export type JobSettingRow = [number, number, string, string, number];

export interface JobSettingObject {
  createdBy: number | null;
  creationDate: number | null;
  lastUpdateDate: number | null;
  lastUpdatedBy: number | null;
  clientId: number;
  key: string;
  value: string;
  id: number;
  jobDetailId: number;
}

export interface JobSettingResponse {
  success: boolean;
  object: JobSettingObject;
  messages: any[];
}

export async function fetchJobSettings({
  clientCode,
  jobDetailId,
}: {
  clientCode: string;
  jobDetailId: number | string;
}): Promise<JobSettingRow[]> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.JOB.JOB_SETTINGS);
  const params = { firstResult: -1, maxResult: 0, jobDetailId };
  const response = await api.get<JobSettingRow[] | any>(endpoint, params);
  return Array.isArray(response) ? (response as JobSettingRow[]) : [];
}

export async function fetchJobSettingKeys({
  clientCode,
}: {
  clientCode: string;
}): Promise<string[]> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.JOB.JOB_SETTING_KEYS);
  const response = await api.get<string[] | any>(endpoint);
  return Array.isArray(response) ? response as string[] : [];
}

export async function updateJobSetting({
  clientCode,
  payload,
}: {
  clientCode: string;
  payload: { value: string; key: string; jobDetailId: number | string; clientId: number; id: number };
}): Promise<JobSettingResponse> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.JOB.JOB_SETTING_UPDATE);
  return api.put<JobSettingResponse>(endpoint, payload);
}

export async function createJobSetting({
  clientCode,
  payload,
}: {
  clientCode: string;
  payload: { value: string; key: string; jobDetailId: number | string; clientId: number };
}): Promise<JobSettingResponse> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.JOB.JOB_SETTING_CREATE);
  return api.post<JobSettingResponse>(endpoint, payload);
}

/** Delete job setting by id. Backend may still be in development; callers should handle errors. */
export async function deleteJobSetting({
  clientCode,
  id,
}: {
  clientCode: string;
  id: number;
}): Promise<void> {
  const endpoint = getEndpoint(clientCode, `${API_ENDPOINTS.JOB.JOB_SETTING_DELETE}${id}`);
  await api.delete(endpoint);
}


